import { createElement, styled, compose, position, layout, flexbox, space, color, typography, border, opacity, listStyle } from '@vebox/etui-system';

const UlElement = createElement('ul');
const Ul = styled(UlElement)(compose(position, layout, flexbox, space, color, typography, border, opacity, listStyle));

export { Ul };
